export const ApiAccessCode = Object.freeze({
    READ: 1,
    WRITE: 2
});

const isReadOnly = (apiAccess) =>
    !apiAccess?.some((access) => ApiAccessCode[access] === ApiAccessCode.WRITE);

export { isReadOnly };
